<template>
	<div>
		<preloader v-if="loading"></preloader>
		<div class="rounded border p-3 m-3 border-style-dashed" @drop.prevent="addFile" @dragover.prevent>
			<button type="button" v-on:click="loadFile()" class="btn btn-light btn-sm rounded-pill mb-2" :disabled="loading" v-if="!dfDisabled">
				<i class="material-icons">attach_file</i> Adjuntar archivo(s)
			</button>
			<div class="form-row" v-if="adjuntos.length>0">
				<div class="col-md-4 mb-2" v-for="(adjunto, index) in adjuntos">
					<div class="card" v-tooltip="adjunto.NOMBRE_ORIGINAL" >
						<div class="card-body p-1">
							<div class="media">
								<div class="align-self-center mr-1">
									<div :class="'fi fi-sm fi-'+adjunto.EXTENSION">
	                                    <div class="fi-content">
	                                        {{adjunto.EXTENSION}}
	                                    </div>
	                                </div>
								</div>
								<div class="media-body text-truncate">
									<span class="file-href" v-on:click.prevent="downloadFile(adjunto.CODIGO, adjunto.NOMBRE_ORIGINAL)">{{adjunto.NOMBRE_ORIGINAL}}</span>
									<small class="text-muted d-block">({{adjunto.SIZE | kb}} kb)</small>
								</div>
								<div class="align-self-center ml-1">
									<button type="button" class="btn btn-link btn-sm p-0" v-on:click="deleteFile(uploadDF ? adjunto.CODIGO : index)" v-if="!dfDisabled">
										<i class="material-icons">delete</i>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<p class="text-muted text-center m-0 align-self-center flex-fill" v-if="!this.dfDisabled">
					Suelte los archivos aquí o haga clic el adjuntar archivo(s) para cargar
				</p>
			</div>
			<div class="d-flex" v-else>
				<p class="text-muted text-center m-0 align-self-center flex-fill" v-if="!this.dfDisabled">
					Suelte los archivos aquí o haga clic el adjuntar archivo(s) para cargar
				</p>
			</div>
			<input type="file" name="file" ref="file" class="d-none" v-on:change="onFileChange" multiple>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['tarea', 'disabled', 'upload'],

		data(){
			return {
				adjuntos: [],
				file: '',
				files: [],
				loading: false,
			}
		},

		mounted(){
			this.cleanField()
		},

		methods: {
			loadFile(){
				this.$refs.file.click()
			},

			addFile(e){
				if (!this.loading && !this.dfDisabled) {
					let droppedFiles = e.dataTransfer.files
					if(!droppedFiles) return
					// this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
					([...droppedFiles]).forEach(f => {
						this.files.push(f)
					})

					if (this.uploadDF) {
						this.uploadFile()
			    	}else{
			    		([...droppedFiles]).forEach(f => {
				    		this.adjuntos.push({
					    		NOMBRE_ORIGINAL: f.name,
								EXTENSION: null,
								CODIGO: 1,
								SIZE: f.size,
				    		})
						})
			    	}
				}
			},

			onFileChange(e) {
		    	let droppedFiles = e.target.files || e.dataTransfer.files
				if(!droppedFiles) return
				// this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
				([...droppedFiles]).forEach(f => {
					this.files.push(f)
				})
				if (this.uploadDF) {
					this.uploadFile()
		    	}else{
		    		([...droppedFiles]).forEach(f => {
			    		this.adjuntos.push({
				    		NOMBRE_ORIGINAL: f.name,
							EXTENSION: null,
							CODIGO: 1,
							SIZE: f.size,
			    		})
					})
		    	}
		    },

		    getFiles(){
				this.loading = true
				var vm = this

	            axios.get(`/api/tareas/${this.codigo}/adjuntos`)
	            .then(function(response){
	        		vm.adjuntos = response.data
	        	})
	        	.catch(function(error){
	        		console.log(error)
	        	}).then(() => {
	        		vm.loading = false
	        	})
			},

		    uploadFile(){
		    	var $module = this
		    	let formData = new FormData()
				this.files.forEach((f,x) => {
					formData.append(`files[${(x)}]`, f)
					x++
				})
	            this.loading = true

	            return new Promise((resolve, reject) => {
	            	if ($module.files.length<=0) {
	            		resolve({})
	            		return;
	            	}
	                axios.post(`/api/tareas/${this.codigo}/adjuntos`,
		               	formData,
		                {
		                	headers: {
		                    	'Content-Type': 'multipart/form-data'
		                	}
		              	}
		        	).then(function(response){
		        		$module.adjuntos.push(response.data)
		        		if ($module.files.length>1) {
		        			$module.$toasted.show('Archivos agregados.')
		        		}else{
		        			$module.$toasted.show('Archivo agregado.')
		        		}
		        		
		        		$module.cleanField()
		        		resolve(response)
		        	})
		        	.catch(function(error){
		        		console.log(error.response)
		        		$module.$toasted.show('Error al agregar archivo.')
		        		$module.cleanField()
		        		reject(error)
		        	}).then(() => {
		        		$module.loading = false
		        	})
	            })
			},

			downloadFile:function(id, name){
				axios({
				    url: `/api/tareas/adjuntos/${id}`,
				    method: 'GET',
				    responseType: 'blob',
				}).then((response) => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]))
					var fileLink = document.createElement('a')

					fileLink.href = fileURL
					fileLink.setAttribute('download', name)
					document.body.appendChild(fileLink)
					fileLink.click()
				})
			},

			deleteFile: function(id){
				var vm = this
				if (!this.uploadDF) {
		    		this.$emit('input', this.files)
		    		vm.adjuntos.splice(id, 1)
		    		return;
		    	}

				this.loading = true
				axios.delete(`/api/tareas/adjuntos/${id}`)
				.then(function(response){
	        		var index = vm.adjuntos.findIndex(x=>x.CODIGO == id)
		    		vm.adjuntos.splice(index, 1)
	        	})
	        	.catch(function(error){
	        		console.log(error)
	        		vm.$toasted.show('Error al eliminar archivo.')
	        	}).then(() => {
	        		vm.loading = false
	        	})
			},

			cleanField(){
				this.$refs.file.value = ''
			},

			resetField(){
				this.adjuntos = []
				this.file = ''
				this.files = []
				this.loading = false
			}
		},

		computed:{
			codigo: function(){
				return this.tarea
			},

			dfDisabled: function(){
				if (this.disabled == "false" || this.disabled == "") {
					return false
				}
				return true
			},

			uploadDF: function(){
				return this.upload;
			}
		},

		filters: {
			kb: function(val){
				return Math.floor(val/1024)
			},
		}
	}
</script>